import { render, staticRenderFns } from "./Amounts.vue?vue&type=template&id=76293d6d"
import script from "./Amounts.vue?vue&type=script&lang=js"
export * from "./Amounts.vue?vue&type=script&lang=js"
import style0 from "./Amounts.vue?vue&type=style&index=0&id=76293d6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports